<template>
    <section class="app-main ">
        <div class="top-bar">
            <el-input v-model="search" @change="handleSearch" class="m-width-4"  placeholder="查询">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
              <el-radio
                v-model="Unsual"
                @change="getData()"
                label="2"
                border
                style="width: 130px;margin-left:30px"
                >加拿大异常</el-radio
              >
              <el-radio
                v-model="Unsual"
                @change="getData()"
                label="1"
                border
                style="width: 130px"
                >海关异常</el-radio
              >
            <!-- <a href="https://myadmin.moobyyoho.com/customsexcelexport" v-show="tableData.length != 0">
                <el-button type="primary" plain>表格导出</el-button>
            </a> -->
        </div>



        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table  :data="tableData" empty-text="暂无盘点数据" height="600" style="width: 100%">
                <el-table-column prop="purchase_pic_url" label="商品图片"   align="center"  >
                    <template slot-scope="scope">
                        <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column prop="barcode"            label="条形码"     align="center"  min-width="140"> </el-table-column>
                <el-table-column prop="purchase_title"     label="商品名称"   align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="batch"              label="批次"       align="center" ></el-table-column>
                <el-table-column prop="attr_symbol_string" label="规格属性"   align="center" >
                    <template slot-scope="scope" v-if="scope.row.attr_symbol_string">    
                        <el-tag size="small" class="m-right-3">{{scope.row.attr_symbol_string}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="customs_num"        label="海关盘点数量"    align="center" ></el-table-column>
                <el-table-column prop="canada_num"         label="加拿大盘点数量"  align="center" ></el-table-column>
                <el-table-column prop="order_num"         label="订货数量"  align="center" ></el-table-column>
                <el-table-column prop="status"         label="状态"  align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0 || scope.row.status == null" style="color:#F56C6C">未解决</span>
                        <span v-else>已解决</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at"         label="入库时间"        align="center" width="160"></el-table-column>
                <el-table-column prop="remarks"         label="备注"        align="center" width="240">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == 0 || scope.row.status == null" type="primary" plain size="mini" @click="scope.row.status = 1">添加备注</el-button>
                        <el-input v-else :autofocus="true" type="textarea" resize="none" placeholder="请输入备注内容" v-model="scope.row.remarks" @change="handleRemarks(scope.row)" @blur="handleRemarks(scope.row)"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :total="total" :page-size="size" @current-change="loadMore" background layout="prev, pager, next, jumper" class="m-pagination" > </el-pagination>
        </el-card>

        


    </section>
</template>

<script>
import { unusual, customs, abnormal_update } from '@/api/warehouse.js'
import tableImg from '@/components/Image.vue'
export default {
    components:{ tableImg },
    data() {
        return {
            search:'',
            tableData:[],     
            total:0,     
            size:20,
            Unsual: '2',
            remarks: ''
        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page,
                spot_search: this.Unsual
            }
            if(this.search != ""){
                params.search = this.search       
            }
            
            unusual(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }else{
                    this.tableData = []
                    this.total     = 0
                }
            })
        },
        // 搜索数据
        handleSearch(){
            // if(this.batch == "" || this.box == ""){
            //     this.$message.error("商品批次、箱号不能为空...")
            //     return false
            // }
            this.page = 1
            this.getData()
        },
        // 页数改变时请求数据
        loadMore(page){
            this.page = page
            this.getData()
        },

        start(){
            
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.box === ""){
                this.$message.error("请完善箱号...")
                return false
            }
            if(this.barcode === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            let params = {
                batch:this.batch,
                box:this.box,
                barcode:this.barcode,
                
            }
            customs(params).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.$refs.input.focus()
                    this.getData()
                }
            })
        },
        // 盘点确认
        handleConfirm(){
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.code === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            
        },
        handleRemarks(row){
            if(row.remarks == null || row.remarks.trim() == '') {
                this.$message.error('内容不能未空')
                this.getData()
                return false
            }
            let params = {
                remarks: row.remarks,
                status: row.status
            }
            abnormal_update(row.id,params).then(res => {
                if(res) {
                    this.$message({type:'success', message:res.msg})
                    this.getData()
                }
            })
        },
        
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>